const parseToHtml = (str) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(str, "text/html");
  return doc.body.children[0];
};
export default parseToHtml;
